// extracted by mini-css-extract-plugin
export default {"switch":"switch_switch__UOq7w","slider":"switch_slider__8YfIb","switchDisabled":"switch_switchDisabled__xutvV"};